import {AgencyRepository} from "../../../repositories/AgencyRepository.ts";
import {CreatePaymentPlanPayload, PaymentPlan} from "../../entities/PaymentPlan.ts";

export class CreateAgencyPaymentPlanUseCase {
    constructor(private readonly agencyRepository: AgencyRepository) {}

    async execute(agencyId: string, payload: CreatePaymentPlanPayload): Promise<PaymentPlan> {
        return this.agencyRepository.createPaymentPlan(agencyId, payload)
    }
}
